/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q4_QuestionInputs */

const en_faq_q4_question = /** @type {(inputs: Faq_Q4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I apply for a refund or cancel my insurance?`)
};

const fr_faq_q4_question = /** @type {(inputs: Faq_Q4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment demander un remboursement ou annuler mon assurance ?`)
};

/**
* | output |
* | --- |
* | "How do I apply for a refund or cancel my insurance?" |
*
* @param {Faq_Q4_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q4_question = /** @type {((inputs?: Faq_Q4_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q4_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q4_question(inputs)
	return fr_faq_q4_question(inputs)
});